import React from "react";
import "../../styles/CostValue.css";

const FancyGetStartedButton = ({ label = "free trial", onMouseOver, onMouseOut,isMouseOver }) => {

  return (
    <>
      <style>{`
        :root {
          --btn-length: 672.1px;
          --btn-length-half: 336.05px;
          --btn-length-third: 224.03px;
          --btn-length-two-thirds: 448.07px;
        }

        @keyframes outer-dashoffset {
          0% {
            stroke-dashoffset: 0;
            stroke-dasharray: var(--btn-length-half) var(--btn-length-half);
          }
          50% {
            stroke-dasharray: var(--btn-length-third) var(--btn-length-two-thirds);
          }
          100% {
            stroke-dashoffset: var(--btn-length);
            stroke-dasharray: var(--btn-length-half) var(--btn-length-half);
          }
        }

        @keyframes inner-dashoffset {
          0% {
            stroke-dashoffset: 0;
            stroke-dasharray: var(--btn-length-half) var(--btn-length-half);
          }
          50% {
            stroke-dasharray: var(--btn-length-third) var(--btn-length-two-thirds);
          }
          100% {
            stroke-dashoffset: calc(-1 * var(--btn-length));
            stroke-dasharray: var(--btn-length-half) var(--btn-length-half);
          }
        }

        .button-line-outer {
          stroke-dasharray: var(--btn-length-half) var(--btn-length-half);
          stroke-dashoffset: 0;
          animation: outer-dashoffset 6s linear infinite;
        }

        .button-line-inner {
          stroke-dasharray: var(--btn-length-half) var(--btn-length-half);
          stroke-dashoffset: 0;
          animation: inner-dashoffset 5s linear infinite;
        }

        .button-wrapper:hover .button-line-outer,
        .button-wrapper:focus .button-line-outer,
        .button-wrapper:hover .button-line-inner,
        
      `}</style>

      <button
        className="
          button-wrapper group inline-flex items-center justify-center gap-3
          min-w-[110px] md:min-w-[160px] lg-xl:min-w-[140px] xl-2xl:min-w-[180px] py-3 px-6 rounded-full
          border border-[#6E3FC6]
          bg-white text-black text-sm md:text-base font-medium
          transition-all duration-300
          hover:bg-[#6E3FC6] hover:text-white
          ml-8 mt-10
          relative overflow-hidden
        "
        onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      >
        {/* Animated SVG border */}
        { isMouseOver && 
        <svg
          className="pointer-events-none absolute inset-0 w-full h-full"
          viewBox="0 0 300 80"
        >
          
          {/* <rect
            className="button-line-outer"
            strokeWidth="6"
            stroke="#16dd41ff"
            strokeLinecap="round"
            fill="none"
            x="4"
            y="4"
            width="292"
            height="72"
            rx="36"
          /> */}
          <rect
            className="button-line-inner"
            strokeWidth="8"
            stroke="#c7c7c9"
            strokeLinecap="round"
            fill="none"
            x="4"
            y="4"
            width="300"
            height="74"
            rx="38"
          />
        </svg>
}

        {/* Label */}
        <span className="relative z-10 md:text-[14px] lg-xl:text-[16px] xl-2xl:text-[17px]">{label}</span>

        {/* Arrow circle */}
        <div
          className="
            relative z-10
            w-6 h-6 rounded-full flex items-center justify-center
            transition-all duration-300
            bg-[#6E3FC6] group-hover:bg-white
          "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="
              w-3.5 h-3.5
              transition-all duration-300
              stroke-white group-hover:stroke-[#6E3FC6]
            "
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M7 17L17 7M8 7h9v9" />
          </svg>
        </div>
      </button>
    </>
  );
};

export default FancyGetStartedButton;